export type TypeFilePathInfo = {
    baseName: string;
    extension: string;
};

// ----------------------------------------------------------------------------

function getPath(filename: string): TypeFilePathInfo {
    const lastSlashIndex = Math.max(filename.lastIndexOf('/'), filename.lastIndexOf('\\'));
    const fileNameOnly = lastSlashIndex >= 0 ? filename.substring(lastSlashIndex + 1) : filename;

    // Last index of the dot
    const lastDotIndex = fileNameOnly.lastIndexOf('.');

    // Check if the file has an extension
    const hasExtension = lastDotIndex > 0;

    // File name without the extension
    const baseName = hasExtension ? fileNameOnly.substring(0, lastDotIndex) : fileNameOnly;

    // File extension (empty string if no extension)
    const extension = hasExtension ? fileNameOnly.substring(lastDotIndex + 1) : '';

    //
    return {
        baseName,
        extension,
    };
}

// ----------------------------------------------------------------------------

export default getPath;
